const faqData = [
  {
    q: '51漫画网是免费的吗？如何访问？',
    a: '51漫画网提供大量免费漫画资源供漫迷阅读，无需注册即可直接访问。您可以通过51漫画网址或搜索"51漫画网页版"进入官方网站，我们提供安全稳定的访问入口，确保您的阅读体验顺畅无忧。',
  },
  {
    q: '51漫画网页版与51漫画官网版有什么区别？',
    a: '两者指向同一个官方平台。51漫画网页版指通过浏览器直接访问的版本，无需下载安装；51漫画官网版适配不同设备，在桌面和移动端均有良好体验。无论使用哪种方式，都能享受到同样的高清漫画资源。',
  },
  {
    q: '漫画更新频率是怎样的？能看到最新连载吗？',
    a: '51漫画平台与各大漫画源保持密切合作，热门连载作品基本实现同步更新。国漫、日漫等主流作品每日均有新章节上线，确保读者第一时间追更。具体更新频率视作品而定，建议收藏关注。',
  },
  {
    q: '使用51漫画网安全吗？会不会有恶意广告？',
    a: '51漫画网作为官方安全入口，高度重视用户访问安全。我们严格筛选内容分发渠道，不使用恶意跳转和强制弹窗广告，为漫迷提供干净、清爽的阅读环境。建议通过51漫画官方渠道访问，以获得最佳体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于51漫画网的常见疑问解答</p>
        </div>
        <div className="space-y-3">
          {faqData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5">
              <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-600 flex-shrink-0 mt-0.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-question-answer-line"></i>
                  </div>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-7">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}